<script>
  import { _ } from 'svelte-intl';
  import CoinIcon from '../CoinIcon.svelte';

  export let user; // : User
</script>

<style lang="stylus">
  .current-balance
    display flex
    justify-content space-between
    align-items center
    border-radius: 10px
    margin: 0 0 24px 0
    padding: 18px 16px
    background: #F7F8FA

  dt
    font-size: 16px
    line-height 24px
    margin 0
    color: $warm-grey

  dd
    font-size: 20px
    font-weight: bold
    line-height: 1
    margin: 0

    span
      vertical-align middle
</style>

{#if user && user.account}
  <dl class="current-balance">
    <dt>{$_('your_balance')}</dt>
    <dd>
      <span>{user.account.balance}</span><CoinIcon />
    </dd>
  </dl>
{/if}
